import React, { forwardRef, useEffect, useRef } from "react";
import { Tooltip } from "@mui/material";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";

const IndeterminateCheckbox = forwardRef(({ indeterminate, ...rest }, ref) => {
  const defaultRef = useRef();
  const resolvedRef = ref || defaultRef;

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return <Form.Check type='checkbox' ref={resolvedRef} {...rest} />;
});

const TableHead = ({
  showColumn,
  columnTitle,
  checkAllCost,
  isIndeterminateCost,
  checkedCostId,
  components,
  viewColumns,
}) => {
  return (
    <thead className='text-center align-middle custom-table-head'>
      <tr>
        <th className='text-center' rowSpan={2} style={{ width: 50 }}>
          BIL.
        </th>
        <th rowSpan={2} className='border-end-0'>
          KOMPONEN PROJEK
        </th>
        <th rowSpan={2} className='border-start-0' />

        {viewColumns.dipohon.checked && (
          <th className={`text-center`} colSpan={2}>
            <p className='mb-0'>PERMOHONAN DISEMAK</p>
          </th>
        )}

        {viewColumns.upen.checked && (
          <th className={`text-center`} colSpan={2}>
            <p className='mb-0'>{columnTitle?.upen} UPEN</p>
          </th>
        )}
        {viewColumns.jppn.checked && (
          <th
            className={`${showColumn?.jppn ? "" : "hide-column"} text-center`}
            colSpan={2}
          >
            <p className='mb-0'>{columnTitle?.jppn} JPPN</p>
          </th>
        )}
        <th
          className={`${showColumn?.cabinet ? "" : "hide-column"} text-center`}
          colSpan={2}
        >
          <p className='mb-0'>{columnTitle?.cabinet} KABINET</p>
        </th>
        <th className='text-center' rowSpan={2}>
          {/* <Tooltip title='Tanda semua' placement='top' arrow followCursor>
            <Form.Group controlId='check_all'>
              <IndeterminateCheckbox
                className='check-box-lg'
                type='checkbox'
                id='check_all'
                indeterminate={isIndeterminate}
                onChange={handleCheckAll}
                checked={
                  project.financial_details?.length === certifiedId.length
                    ? true
                    : false
                }
              />
            </Form.Group>
          </Tooltip> */}
        </th>
      </tr>
      <tr>
        {viewColumns.dipohon.checked && (
          <>
            <th className='border-end-0'>KOS (RM)</th>
            <th>SILING (RM)</th>
          </>
        )}
        {/* UPEN SECTION */}
        {viewColumns.upen.checked && (
          <>
            <th className='border-end-0'>KOS (RM)</th>
            <th>SILING (RM)</th>
          </>
        )}

        {/* JPPN SECTION */}
        {viewColumns.jppn.checked && (
          <>
            <th
              className={`${
                showColumn.jppn ? "" : "hide-column"
              } text-center border-end-0`}
            >
              KOS (RM)
            </th>
            <th
              className={`${showColumn.jppn ? "" : "hide-column"} text-center`}
            >
              SILING (RM)
            </th>
          </>
        )}

        {/* CABINET SECTION */}
        <th
          className={`${
            showColumn.cabinet ? "" : "hide-column"
          } text-center border-end-0`}
        >
          KOS (RM)
        </th>
        <th
          className={`${showColumn.cabinet ? "" : "hide-column"} text-center`}
        >
          SILING (RM)
        </th>
      </tr>
    </thead>
  );
};

export default TableHead;
